import React, { useState } from "react";
import { HashRouter as Router, Switch, Route } from "react-router-dom";
import { LanguageContext } from "./language-context";
import { createGlobalStyle } from "styled-components";
import { CookieBanner } from "./components/CookieBanner";
import { Navbar } from "./components/Navbar";
import { Home } from "./components/Home";
import { Cycle } from "./components/Cycle";
import { Artwork } from "./components/Artwork";
import { Poetry } from "./components/Poetry";
import { ExhibitionList } from "./components/ExhibitionList";
import { ExhibitionItem } from "./components/ExhibitionItem";
import { Biography } from "./components/Biography";
import { Contact } from "./components/Contact";
import { Error } from "./components/Error";
import { pl } from "./data/pl";
import { en } from "./data/en";
import { de } from "./data/de";

const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    font-family: 'Oswald', sans-serif;
    overflow-x: hidden;
    letter-spacing: 0.1rem;
  }
`;

const App = () => {
  let detectedLanguage = "";

  if (localStorage.getItem("lang") === "pl") {
    detectedLanguage = pl;
  } else if (localStorage.getItem("lang") === "de") {
    detectedLanguage = de;
  } else if (localStorage.getItem("lang") === "en") {
    detectedLanguage = en;
  } else if (navigator.language.includes("pl")) {
    detectedLanguage = pl;
  } else if (navigator.language.includes("de")) {
    detectedLanguage = de;
  } else {
    detectedLanguage = en;
  }

  const [userLanguage, setUserLanguage] = useState(detectedLanguage);

  const changeToPl = () => {
    localStorage.setItem("lang", "pl");
    setUserLanguage(pl);
  };

  const changeToEn = () => {
    localStorage.setItem("lang", "en");
    setUserLanguage(en);
  };

  const changeToDe = () => {
    localStorage.setItem("lang", "de");
    setUserLanguage(de);
  };

  const usedLanguage = userLanguage;

  sessionStorage.setItem("page_to", "home");
  sessionStorage.setItem("page_from", "home");
  sessionStorage.setItem("scroll_tracker", "0");

  return (
    <LanguageContext.Provider
      value={{
        language: usedLanguage,
        changeToPl: changeToPl,
        changeToEn: changeToEn,
        changeToDe: changeToDe,
      }}
    >
      <Router>
        <GlobalStyle />
        <CookieBanner />
        <Navbar />
        {/* <Sidebar /> */}
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/cycles/:slug" component={Cycle} />
          <Route exact path="/artworks/:slug" component={Artwork} />
          <Route exact path="/poetry/:slug" component={Poetry} />
          <Route exact path="/exhibitions" component={ExhibitionList} />
          <Route exact path="/reports/:slug" component={ExhibitionItem} />
          <Route exact path="/biography" component={Biography} />
          <Route exact path="/contact" component={Contact} />
          <Route path="*" component={Error} />
        </Switch>
      </Router>
    </LanguageContext.Provider>
  );
};

export { App };
